import {
  WorkflowEvent,
  WorkflowEventState,
  WorkflowEventTypes,
} from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import PortalServiceClient from '../../../api/PortalServiceClient';
import constants from '../../../common/constants';
import UserProfile from '../../../model/UserProfile';
import LoadingPage from '../../common/LoadingPage';
import ReviewFeedbackItem from './ReviewFeedbackItem';
import { Box, ExpandableSection } from '@amzn/awsui-components-core';

interface ReviewFeedbackProps {
  workflowEvents: WorkflowEvent[];
  reviewerUserIds: string[];
  visible?: boolean;
}

interface ReviewFeedbackState {
  reviewerUserProfiles: UserProfile[];
}

class ReviewFeedback extends React.Component<ReviewFeedbackProps, ReviewFeedbackState> {
  private readonly portalServiceClient: PortalServiceClient;

  constructor(props: ReviewFeedbackProps) {
    super(props);
    this.portalServiceClient = PortalServiceClient.create();
    this.state = {
      reviewerUserProfiles: [],
    };
  }

  public componentDidUpdate(prevProps: ReviewFeedbackProps) {
    if (this.props !== prevProps) {
      this.updateReviewerUserProfiles();
    }
  }

  public componentDidMount() {
    this.updateReviewerUserProfiles();
  }

  public render() {
    const { workflowEvents, reviewerUserIds, visible } = this.props;
    const { reviewerUserProfiles } = this.state;
    if (!visible) {
      return null;
    }

    if (workflowEvents.length > 0) {
      const typesToDisplay = [
        WorkflowEventTypes.APPROVE,
        WorkflowEventTypes.DISAPPROVE,
        WorkflowEventTypes.LOCK,
        WorkflowEventTypes.PUBLISH,
        WorkflowEventTypes.REJECT,
        WorkflowEventTypes.UNPUBLISH,
        WorkflowEventTypes.SEND_FOR_REVIEW,
        WorkflowEventTypes.FINALIZE,
        WorkflowEventTypes.DISTRIBUTE,
        WorkflowEventTypes.REVOKE,
        WorkflowEventTypes.EDIT_CONTENT_TYPE,
        WorkflowEventTypes.RETRACT_REVIEW,
        WorkflowEventTypes.PREAUTHORING_APPROVE,
        WorkflowEventTypes.PREAUTHORING_REJECT,
        WorkflowEventTypes.PREAUTHORING_NEED_MORE_INFO,
        WorkflowEventTypes.NO_UPDATES_NEEDED,
        WorkflowEventTypes.UPDATES_NEEDED,
        WorkflowEventTypes.UNPUBLISH_RECOMMENDED,
        WorkflowEventTypes.CONFIRM_UNPUBLISH,
        WorkflowEventTypes.PROPOSAL_APPROVE,
      ];
      const filteredEvents = workflowEvents.filter(
        (e) => typesToDisplay.includes(e.type) && e.state === WorkflowEventState.APPLIED,
      );
      const reviewFeedbackItems = filteredEvents.map((e) => (
        <ReviewFeedbackItem key={e.eventId} workflowEvent={e} />
      ));

      return (
        <Box padding={'s'}>
          <ExpandableSection headerText={constants.WORKFLOW_DETAILS}>
            <div id="review-feedback">{reviewFeedbackItems}</div>
          </ExpandableSection>
        </Box>
      );
    } else {
      if (!reviewerUserProfiles) {
        return <LoadingPage />;
      }
      const noReviewFeedbackItems = reviewerUserProfiles.map((u) => (
        <div key={u.userId}>
          {u.name}: {'No actions'}
        </div>
      ));
      return (
        <Box padding={'s'}>
          <ExpandableSection headerText={constants.WORKFLOW_DETAILS}>
            <div id="review-feedback">{noReviewFeedbackItems}</div>
          </ExpandableSection>
        </Box>
      );
    }
  }

  private updateReviewerUserProfiles = async () => {
    const { reviewerUserIds } = this.props;
    const reviewerUserProfiles = await this.portalServiceClient.getUserProfiles(reviewerUserIds);

    this.setState({
      reviewerUserProfiles,
    });
  };
}

export default ReviewFeedback;
